import styled, { css } from 'styled-components';

export type PopMenuExpandDirection = 'top' | 'bottom';
export type PopMenuHorizontalDirection = 'left' | 'right';

export interface PopMenuProps {
	height: number;
	$expandDirection: PopMenuExpandDirection;
	$horizontalDirection: PopMenuHorizontalDirection;
}

export const PopMenuButtonContainer = styled.div`
	position: relative;
	display: flex;
	height: 100%;
`;

export const PopMenuTrigger = styled.div`
	user-select: none;
	height: 100%;
`;

export const PopMenu = styled.div<PopMenuProps>`
	${({ height, $expandDirection, $horizontalDirection }) => css`
		position: absolute;
		${$horizontalDirection}: 4px;
		${$expandDirection === 'top' ? 'bottom' : 'top'}: ${height + 5}px;
		z-index: 1;
	`}
`;
